import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import './index.css'
import App from './App.tsx'
import { PulseErrorFallback } from './components/PulseErrorFallback'
import { initSentry } from './lib/sentry'

initSentry()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<PulseErrorFallback />}>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>,
)
